import PropTypes from 'prop-types';
import React from 'react';
import { FormControl } from 'react-bootstrap';
import { jobTypes } from '../../util/helpers/jobManipulators';
import JobTaskSpec from '../../stores/specs/JobTaskSpec';

const jobTypeMenuOption = jobType => (
  <option key={jobType} value={jobType}>{jobType}</option>
);

const jobTypeOptions = (currentJobType) => {
  const jobs = jobTypes.map(job => job.jobType);
  const options = jobs.map(job => jobTypeMenuOption(job));
  if (!!currentJobType && jobs.indexOf(currentJobType) === -1) {
    options.push(jobTypeMenuOption(currentJobType));
  }
  return options;
};

const JobTypeInput = ({ task, readOnly, updateTask, taskIndex }) => {
  if (readOnly) {
    return (
      <FormControl
        type='text'
        value={task.jobType}
        className='saved-job-form-readonly'
      />
    );
  }

  return (
    <FormControl
      componentClass='select'
      placeholder='select'
      value={task.jobType}
      onChange={e => updateTask(e, taskIndex, 'jobType')}
    >
      <option key='default' value={''}>Select job type</option>
      {jobTypeOptions(task.jobType)}
    </FormControl>
  );
};

JobTypeInput.propTypes = {
  task: PropTypes.instanceOf(JobTaskSpec),
  readOnly: PropTypes.bool,
  updateTask: PropTypes.func,
  taskIndex: PropTypes.number,
};

export default JobTypeInput;
